const RouteUrl = {
    // Host: `https://exploro-backend.onrender.com`,
    Host: `http://localhost:3001`
}

export default RouteUrl;